var React = require('react');

function SearchInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5","d":"m15.801 15.718 4.259 4.268M18.167 9.552c0 4.715-3.813 8.537-8.518 8.537-4.704 0-8.517-3.822-8.517-8.537 0-4.715 3.813-8.537 8.517-8.537 4.705 0 8.518 3.822 8.518 8.537Z"}));
}

SearchInline.defaultProps = {"width":"21","height":"21","viewBox":"0 0 21 21","fill":"none"};

module.exports = SearchInline;

SearchInline.default = SearchInline;
